{
    "warning": "VARNING!",
    "message": "Ange inte eller klistra in kod du inte förstår.\nNär du använder den här konsolen kan hackare härma din identitet eller stjäla din information med en attack som heter Self-XSS."
}
